import React from 'react'
import { presenceErrorClass, isEmail, isMobile } from 'servos/formValidations'
import { getTrackingId } from 'utils/tracking'

import ContinueButton from 'components/ContinueButton'
import Checkbox from '../../../common/components/Checkbox'
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: 'GTM-N6JGZFJ'
}
TagManager.initialize(tagManagerArgs)

class RegistrationForm extends React.Component {
  state = {
    userName: '',
    userEmail: '',
    userMobile: '',
    errors: {},
    termsAccepted: false,
    submitEnabled: true,
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.errors !== prevProps.errors) {
      this.setState({errors: this.props.errors, submitEnabled: true })
    }
  }

  onChangeName = (e)  => {
    this.setState({userName: e.currentTarget.value})
    let errors = {}
    this.setState({ errors: {} })
  }

  onChangeEmail = (e)  => {
    this.setState({userEmail: e.currentTarget.value})
    let errors = {}
    this.setState({ errors: {} })
  }

  onChangeMobile = (e)  => {
    this.setState({userMobile: e.currentTarget.value})
    let errors = {}
    this.validateMobile(errors, e.currentTarget.value)
    this.setState({ errors })
  }

  validateMobile = (errors, value) => {
    const userMobile = value ? value : this.state.userMobile;

    if ( userMobile.length === 0) {
      errors['userMobile'] = I18n.t('onboarding.registration.errors.mobile.presence')
    }

    if (userMobile && userMobile.length >= 10 && !isMobile(userMobile)) {
      errors['userMobile'] = I18n.t('loan_application_user.profile.errors.mobile')
    }
  }

  validateName = (errors) => {
    if ( !(this.state.userName.length > 0) ) {
      errors['userName'] = I18n.t('onboarding.registration.errors.name.presence')
    }
  }

  validateEmail = (errors, value) => {
    const userEmail = value ? value : this.state.userEmail;

    if ( userEmail.length === 0) {
      errors['userEmail'] = I18n.t('onboarding.registration.errors.email.presence')
    }

    if ( (userEmail.length > 0 && !isEmail(userEmail)) ) {
      errors['userEmail'] = I18n.t('onboarding.registration.errors.email.format')
    }
  }

  isValid = () => {
    let errors = {}
    this.validateName(errors)
    this.validateMobile(errors)
    this.validateEmail(errors)

    this.setState({ errors })
    return Object.keys(errors).length === 0
  }

  submit = () => {
    if (this.isValid()) {
      this.setState({ submitEnabled: false })
      let { userName, userMobile, userEmail, termsAccepted } = this.state
      const gclid = getTrackingId('gclid')
      const msclkid = getTrackingId('msclkid')
      window.dataLayer.push({
        event:'formec',
        enhanced_conversion_data: {
          email: userEmail,
          supplied_email: userEmail,
          mobile: userMobile,
          gclid: gclid,
          msclkid: msclkid,
        }
      });

      this.props.onRegistrationSubmit({
        userName: userName,
        userEmail: userEmail,
        userMobile: userMobile,
        termsAndConditions: termsAccepted,
        termsAcceptedAt: new Date(),
      })
    }
  }

  render() {
    let {
      userName,
      userEmail,
      userMobile,
      errors,
      submitEnabled,
      termsAccepted,
    } = this.state
    const gclid = getTrackingId('gclid')
    const msclkid = getTrackingId('msclkid')

    return(
      <div>
        <div className='form-group'>
          <label>Name</label>
          <input className={ `form-control ${presenceErrorClass(errors['userName'])}` }
                 type="text"
                 placeholder="Name"
                 onChange={ (e) => { this.onChangeName(e) } }
                 value={ userName } />
          <div className="invalid-feedback">
            { errors['userName'] }
          </div>
        </div>

        <div className='form-group'>
          <label>Mobile</label>
          <input className={ `form-control ${presenceErrorClass(errors['userMobile'])}` }
                 placeholder='Mobile'
                 onChange={ (e) => { this.onChangeMobile(e) } }
                 value={ userMobile }
                 type='numeric'
          />
          <div className="invalid-feedback">
            { errors['userMobile'] }
          </div>
        </div>

        <div className='form-group'>
          <label>Email address</label>
          <input className={ `form-control ${presenceErrorClass(errors['userEmail'])}` }
                 placeholder='Email address'
                 onChange={ (e) => { this.onChangeEmail(e) } }
                 value={ userEmail }
                 type='email'
          />
          <div className="invalid-feedback">
            { errors['userEmail'] }
          </div>
          {gclid &&
            <input type="hidden" id="gclid_field" name="gclid_field" value={gclid} />
          }
          {msclkid &&
            <input type="hidden" id="msclkid_field" name="msclkid_field" value={msclkid} />
          }
        </div>

        <Checkbox
          checked={ this.state.termsAccepted }
          onClick={ (e) => this.setState({termsAccepted: e.currentTarget.checked})}
          id='accept-terms'
        >
          I have read and consent to <a href='/pages/privacy' target='_blank'>Yard’s Privacy &amp; Cookies Policy</a>, <a href='/pages/credit-guide' target='_blank'>Credit
          Guide</a> and <a href='/pages/terms' target='_blank'>Website
          Terms &amp; Conditions</a>, and to Yard using my personal information to contact me regarding my application.
        </Checkbox>

        <br />
        <ContinueButton onClick={ this.submit } enabled={ submitEnabled && termsAccepted } />
        <br />
        <br />
      </div>
    )
  }
}

export default RegistrationForm
